<!--
// app/components/pages/teams-team/CardPresidentTeamPage.vue
-->
<script setup lang="ts">
import { setAliasUrl } from "#shared/Shared/utils";
import { useRegions } from "~/composables/regions";

type Props = {
  presidentName: string;
  presidentTitle: string;
  presidentImage?: string;
};

defineProps<Props>();

const { isNations } = useRegions();
</script>

<template>
  <div :class="['card-president', { 'max-h-[513px]': !isNations }]">
    <div class="container-president-img">
      <NuxtImg
        v-if="presidentImage"
        :src="setAliasUrl(presidentImage)"
        :alt="presidentName"
        width="1018"
        height="649"
        fit="outside"
        sizes="320px sm:336px"
        class="w-full h-auto object-top object-contain"
      />
    </div>
    <div class="bg-gray-900 text-center py-4 px-2">
      <p :class="isNations ? 'president-name-small' : 'president-name'">{{ presidentName }}</p>
      <p class="president-title">{{ presidentTitle }}</p>
    </div>
  </div>
</template>

<style scoped>
.card-president {
  @apply overflow-hidden rounded-lg flex bg-gray-800 flex-col gap-0 max-w-[336px] h-full;
}

.container-president-img {
  @apply bg-[url('/img/bg-card/bg-card-president-team-page.jpg')] relative overflow-hidden bg-cover bg-center;
  @apply bg-no-repeat h-full w-full pt-3;
}

.container-president-img::after {
  content: "";
  background-image: linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0) 100%);
  @apply absolute bottom-0 w-full h-20 z-[2];
}

.president-name {
  @apply text-3xl font-bold;
}

.president-name-small {
  @apply text-xl font-bold;
}

.president-title {
  @apply text-sm text-gray-400;
}
</style>
